export const QUANTITY_MAX = 999_999_999;
export const DIMENSION_MAX = 999.99;
export const UOM_SKU_MAX_LENGTH = 200;
export const CONTAINS_ID_UNSET = 0;
